var map = {
	"./add.svg": "76a4",
	"./circle.svg": "b289",
	"./duplicate.svg": "5ca2",
	"./ellipse.svg": "4e7f",
	"./eraser.svg": "3b6f",
	"./free.svg": "380e",
	"./image.svg": "931c",
	"./line.svg": "aa4c",
	"./palette.svg": "1e83",
	"./pencil.svg": "e51f",
	"./rectangle.svg": "3bba",
	"./redo.svg": "63dc",
	"./reset.svg": "c680",
	"./resize.svg": "605c",
	"./rotate-clockwise.svg": "7480",
	"./rotate-counterclockwise.svg": "7d9b",
	"./save.svg": "9344",
	"./select.svg": "9878",
	"./text.svg": "d36f",
	"./triangle.svg": "a8fe",
	"./undo.svg": "34b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";